import * as React from 'react';

export const MemberFormHeading: React.StatelessComponent = ({ children }) => (
	<div className="panel-heading">{children}</div>
);
